import $ from 'jquery';

export default class {
	constructor(options) {
		const defaults = {
			el: '#finalScene',
			dom: {
				change: '#finalSceneChange',
				social: '.js-final-scene-social',
				name: '#finalSceneName',
				out: '#finalSceneOut',
				num: '#finalSceneNum',
				fromName: '#finalSceneFromName',
				fromCode: '#finalSceneFromCode',
				toName: '#finalSceneToName',
				toCode: '#finalSceneToCode'
			},
			classes: {
				share: 'final-scene final-scene_share_'
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
		this.$window = $(window);
		this.id = false;
		this.data = {};
		this.change = 1;
		this.maxChange = 5;
		return this;
	}

	get() {
		this.$change = this.$el.find(this.options.dom.change);
		this.$social = this.$el.find(this.options.dom.social);
		this.$name = this.$el.find(this.options.dom.name);
		this.$out = this.$el.find(this.options.dom.out);
		this.$num = this.$el.find(this.options.dom.num);
		this.$fromName = this.$el.find(this.options.dom.fromName);
		this.$fromCode = this.$el.find(this.options.dom.fromCode);
		this.$toName = this.$el.find(this.options.dom.toName);
		this.$toCode = this.$el.find(this.options.dom.toCode);

		return this;
	}

	onChange() {
		const self = this;
		self.change++;

		if (self.change > self.maxChange) {
			self.change = 1;
		}

		const data = {};
		data['request-id'] = self.id;
		data['bg-index'] = self.change;

		$.ajax({
			url: self.$change.data('action'),
			type: self.$change.data('method'),
			data: data,
			dataType: 'json',
			success: function (json) {
				if (json && json.error) {
					if (json.message) {
						alert(json.message);
					}
				}
				if (json && json.shareUrl) {
					self.setShareUrl(json.shareUrl);
					self.setBackground(data['bg-index']);
				}
			}
		});
	}

	setBackground(num) {
		this.$el.attr('class', this.options.classes.share + num);
	}

	setShareUrl(url) {
		const share = url;
		this.$social.each(function () {
			const $this = $(this);
			if ($this.data('encode') === 'yes') {
				$this.attr('href', $this.data('href') + encodeURIComponent(share));
			}else {
				$this.attr('href', $this.data('href') + share);
			}
		});
		return this;
	}

	onSet = (event, id, data, json, all) => {
		this.id = id;
		this.change = 1;
		const name = data['last-name'].charAt(0).toUpperCase() + data['last-name'].slice(1).toLowerCase()
						+ ' ' + data.name.charAt(0).toUpperCase()
						+ '.' + data['second-name'].charAt(0).toUpperCase() + '.';

		this.$name.html(name);
		this.$out.html(json.out);
		this.$num.html(json.num);
		this.$fromName.html(json.direction.from.name);
		this.$fromCode.html(json.direction.from.code);
		this.$toName.html(json.direction.to.name);
		this.$toCode.html(json.direction.to.code);

		this.setShareUrl(all.shareUrl);

		this.setBackground(this.change);
	}

	init() {
		this.$window.on('requestId.set', this.onSet.bind(this));
		this.$change.on('click', this.onChange.bind(this));
	}

	render() {
		if (this.$el.length) {
			this
				.get()
				.init();
		}
	}
}



// WEBPACK FOOTER //
// ./app/blocks/final-scene/final-scene.js